import { render, staticRenderFns } from "./NatureTalentDataArea.vue?vue&type=template&id=2a11fa00&"
import script from "./NatureTalentDataArea.vue?vue&type=script&lang=js&"
export * from "./NatureTalentDataArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports